import { render, staticRenderFns } from "./UnregisteredUser.vue?vue&type=template&id=59312f24&"
import script from "./UnregisteredUser.vue?vue&type=script&lang=js&"
export * from "./UnregisteredUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports